import React from 'react'
import {  Row, Col, Card } from "react-bootstrap"
import logo_cu from "./../../assets/images/logo_cu.svg"
import { redirectClaveUnica } from "./../../services/auth.service"

const LoginOptions = ({setShowLogin}) => {
  	const loginCU = () => {
			redirectClaveUnica()
		}

  return (
		<Row className="mt-3">
			<Col md={{ span: 4, offset: 2 }}>
				<Card className="text-center card-hover">
					<Card.Body>
						<p>
							Docentes: <br /> Ingrese con su Clave Única
						</p>
						<img src={logo_cu} alt="clave unica" /> <br />
						<span className="btn-cu hover-shw stretched-link" onClick={() => loginCU()}>
							<span className="cl-claveunica"></span>
							<span className="texto">Iniciar sesión</span>
						</span>
					</Card.Body>
				</Card>
			</Col>

		<Col md={{ span: 4 }}>
				<Card className="text-center h-100 card-hover">
					<Card.Body className="d-flex flex-column">
						<p>
							Estudiantes: <br /> Ingrese con su Correo Institucional.
						</p>
						<div className="mt-auto">
							<span className="btn-cu stretched-link " onClick={() => setShowLogin(true)}>
								<span className="texto">Iniciar sesión (E-mail)</span>
							</span>
						</div>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	)
}

export default LoginOptions
